import React from 'react';
import Badge from '@mui/material/Badge';
import MailIcon from '@mui/icons-material/Mail';
export default function BadgeMax({value}) {
 return <Badge color="secondary" badgeContent={Number(value)||0} max={999}><MailIcon/></Badge>;
}
